module.exports = __webpack_public_path__ + "edd6e3a97bcd553def6928dd35cf660d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/11.jpg
// module id = 281
// module chunks = 0